export default {
  ads_readonly: [
    {
      section: ['ads'],
      type: 'readonly',
    },
    {
      section: ['fin'],
      type: 'full_access',
    },
  ],
  fin_readonly: [
    {
      section: ['ads'],
      type: 'full_access',
    },
    {
      section: ['fin'],
      type: 'readonly',
    },
  ],
  readonly: [
    {
      section: ['fin', 'ads'],
      type: 'readonly',
    },
  ],
  full_access: [
    {
      section: ['fin', 'ads'],
      type: 'full_access',
    },
  ],
  vkads_full_readonly_access: [
    {
      section: ['fin', 'ads'],
      type: 'readonly',
    },
  ],
  vkads_ads_only_readonly_access: [
    {
      section: ['ads'],
      type: 'readonly',
    },
  ],
  vkads_fin_only_readonly_access: [
    {
      section: ['fin'],
      type: 'readonly',
    },
  ],
}
